import { render, staticRenderFns } from "./userRatingListItem.vue?vue&type=template&id=bf5087c8&scoped=true&"
import script from "./userRatingListItem.vue?vue&type=script&lang=js&"
export * from "./userRatingListItem.vue?vue&type=script&lang=js&"
import style0 from "./userRatingListItem.vue?vue&type=style&index=0&id=bf5087c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5087c8",
  null
  
)

export default component.exports